// eslint-disable-next-line import/no-extraneous-dependencies
import Auth from '@aws-amplify/auth';

export const signOut = () => {
  Auth.signOut();
};
